/**
 * Sistema de marcadores del world map.
 * Cada personaje tiene su propio set persistido en localStorage.
 */

export interface MapMarker {
  id: string;
  mapId: string;
  tileX: number;
  tileY: number;
  label: string;
  color: number;       // hex (default 0xffd400 amarillo)
  createdAt: number;
}

const STORAGE_PREFIX = 'aureum_map_markers_v1_';

function safeRandomId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

export function newMarkerId(): string {
  return safeRandomId();
}

export function loadMarkers(characterId: string): MapMarker[] {
  if (!characterId || typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_PREFIX + characterId);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as MapMarker[];
    if (!Array.isArray(parsed)) return [];
    // Saneo defensivo de cada entry para no crashear si el storage está corrupto.
    return parsed.filter((m) =>
      typeof m?.id === 'string'
      && typeof m?.mapId === 'string'
      && typeof m?.tileX === 'number'
      && typeof m?.tileY === 'number'
      && typeof m?.label === 'string'
      && typeof m?.color === 'number'
      && typeof m?.createdAt === 'number'
    );
  } catch {
    return [];
  }
}

export function saveMarkers(characterId: string, markers: MapMarker[]): void {
  if (!characterId || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_PREFIX + characterId, JSON.stringify(markers));
  } catch {
    // Ignorar QuotaExceededError / acceso denegado.
  }
}
